import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAppSelector } from "../../store";
import { appAxios } from "../../axios/axios";
import { EnumVisaCategory, IVisaEnquiry } from "../types/flights";
import { SelectWrapper } from "../Common/Ui/SelectWrapper";
import CreateNewAgent from "../FlightEnquiryForm/CreateNewAgent";
import { getAuthToken } from "../../commonGlobals/functions/localStorage/getUser";
import { LoadingButton } from "../Common/Ui/LoadingButton";
import { AdultChildDetails } from "../Common/AdultChildDetails";
import { CustomStaticSelect } from "../Common/Ui/CustomStaticSelect";
import { useLocation, useNavigate } from "react-router-dom";
const CustomCkEditor = React.lazy(() => import("../Common/Ui/CustomCkEditor"));

const visaCategoryOptArr = [
  {
    value: "tourist",
    label: "Tourist",
  },
  {
    value: "business",
    label: "Business",
  },
  {
    value: "visitor",
    label: "Visitor",
  },
];

const VisaEnquiryTab: React.FC<{
  onSaveEnquiry?: any;
  onBehalfByStaff?: boolean;
  userData?: any;
}> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const visaData: IVisaEnquiry = location?.state?.enquiryData;
  const enquiryId: number = location?.state?.enquiryId;
  const isUpdating = visaData ? true : false;
  const [passengerPopup, setPassengerPopup] = useState(false);
  const [visaQuery, updateVisaQuery] = useState<IVisaEnquiry>({
    remark: "",
    visaEnquires: [],
    type: "Visa Enquiry",
    noOfAdult: 1,
    noOfChild: 0,
    noOfInfant: 0,
  });
  // const [captchaToken, setCaptchaToken] = useState<string | undefined>(
  //   undefined
  // );
  // const reCaptchaRef = useRef<any>();
  const [handleModalClose, setHandleModalClose] = useState(false);
  const userModalHandleClose = () => setHandleModalClose(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const isLoggedIn = getAuthToken();

  const insertVisaEnquiry = () => {
    if (visaQuery.visaEnquires && visaQuery.visaEnquires?.length >= 5) {
      return;
    }
    updateVisaQuery((old) => {
      old.visaEnquires?.push({
        country: "",
        visaCategory: "tourist",
      });
      return { ...old };
    });
  };

  useEffect(() => {
    if (visaQuery.visaEnquires && visaQuery.visaEnquires?.length < 1) {
      insertVisaEnquiry();
    }
  }, []);

  const [visaCountriesState, setVisaCountriesState] = useState<Array<any>>([]);
  const siteData = useAppSelector((state) => state.siteData);

  useEffect(() => {
    getVisaCountries();
    if (visaData) {
      updateVisaQuery(visaData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getVisaCountries = async () => {
    try {
      const visaCountries = await appAxios({
        url: "/api/getCountries",
        method: "GET",
      });

      setVisaCountriesState(visaCountries.data.result);
    } catch (error: any) {
      toast.error(
        error.errorMessage || error.message || "Unable to fetch Countries"
      );
    }
  };

  const validateVisaData = () => {
    if (!visaQuery.remark || visaQuery.remark.trim().length === 0) {
      toast.error("Please enter remark");
      return false;
    }
    for (let index in visaQuery.visaEnquires) {
      const visa = visaQuery.visaEnquires[index];
      if (visa.country.length === 0) {
        toast.error("Please Select Country");
        return false;
      }
    }
    return true;
  };

  const saveEnquiry = async () => {
    try {
      if (!validateVisaData()) {
        return;
      }
      if (!isLoggedIn) {
        return setHandleModalClose(true);
      }
      // let token;
      // if (!captchaToken) {
      //   token = await reCaptchaRef.current.executeAsync();
      //   setCaptchaToken(token);
      // }
      // if (!captchaToken && !token) {
      //   return toast.error("Please solve captcha");
      // }

      setRequestLoading(true);
      const url = "/query/saveVisaEnquiry";
      const dataToBeSend = props.onBehalfByStaff
        ? {
            enquiryData: visaQuery,
            userData: props.userData && props.userData,
            isOnBehalf: props.onBehalfByStaff,
          }
        : {
            enquiryData: visaQuery,
          };
      // return alert(JSON.stringify(dataToBeSend));

      const saveResponse = await appAxios(url, {
        method: "POST",
        data: dataToBeSend,

        // headers: {
        //   "captcha-token": captchaToken ? captchaToken : token,
        // },
      });
      if (saveResponse.data.success) {
        props.onSaveEnquiry && props.onSaveEnquiry();
        updateVisaQuery({
          remark: "",
          visaEnquires: [
            {
              country: "",
              visaCategory: "tourist",
            },
          ],
          noOfAdult: 1,
          noOfChild: 0,
          noOfInfant: 0,
          type: "Visa Enquiry",
        });
        toast.success("Enquiry saved successfully");
      }
    } catch (error: any) {
      const errorMessage = "Unable to save enquiry!!";
      toast.error(errorMessage);
    } finally {
      setRequestLoading(false);
    }
    // reCaptchaRef.current.reset();
    // setCaptchaToken(undefined);
  };

  const updateEnquiry = async () => {
    if (!validateVisaData()) {
      console.log("ff");

      return;
    }
    // let token;
    // if (!captchaToken) {
    //   token = await reCaptchaRef.current.executeAsync();
    //   setCaptchaToken(token);
    // }
    // if (!captchaToken && !token) {
    //   return toast.error("Please solve captcha");
    // }
    setRequestLoading(true);
    try {
      const updateResponse = await appAxios("/query/updateEnquiry", {
        method: "POST",
        // headers: {
        //   "captcha-token": captchaToken ? captchaToken : token,
        // },
        data: {
          enquiryData: {
            id: enquiryId,
            ...visaQuery,
          },
        },
      });
      if (updateResponse.data.success) {
        toast.success("Enquiry updated successfully");
        navigate(`/enquiry/${enquiryId}`, {
          replace: true,
        });
      }
    } catch (error) {
      const errorMessage = "Unable to update enquiry!!";
      toast.error(errorMessage);
    }
    setRequestLoading(false);
    // reCaptchaRef.current.reset();
    // setCaptchaToken(undefined);
  };

  const removeSegment = (index) => {
    updateVisaQuery((old) => {
      if (old.visaEnquires && old.visaEnquires.length > 1) {
        old.visaEnquires.splice(index, 1);
      }
      return {
        ...old,
      };
    });
  };

  return (
    <div className="tab-pane active p-4 visa-module">
      <div className="module-name">
        <h3 className="after-heading">Visa Enquiry</h3>
      </div>

      <div className="row">
        <div className="col-lg-9">
          {visaQuery.visaEnquires?.map((visa, index) => (
            <div className="row" key={index}>
              <div className="col-lg-4">
                <label htmlFor="">Country</label>
                <SelectWrapper
                  className="locationSelect Container text-secondary"
                  // placeholder={"Select Country"}
                  options={visaCountriesState.map((country: any) => ({
                    label: `${country?.country_name}`,
                    value: country?.country_name,
                  }))}
                  onChange={(val) => {
                    updateVisaQuery((old) => {
                      old.visaEnquires &&
                        (old.visaEnquires[index].country = val?.value);
                      return { ...old };
                    });
                  }}
                  value={
                    (visa.country && visa.country.length) !== 0
                      ? visa.country
                      : undefined
                  }
                />
              </div>

              <div className="col-lg-4 small">
                <CustomStaticSelect
                  label="Visa Category"
                  id="category"
                  value={visa.visaCategory}
                  onChange={(e) => {
                    updateVisaQuery((old) => {
                      old.visaEnquires &&
                        (old.visaEnquires[index].visaCategory = e.target
                          .value as EnumVisaCategory);
                      return { ...old };
                    });
                  }}
                  optionArr={visaCategoryOptArr}
                />
                <div className="remove-btn text-end">
                  <button
                    type="button"
                    className="minus-btn"
                    onClick={() => removeSegment(index)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="col-lg-3">
          <div className="add-visa-enquiry-button">
            <button
              className="btn btn-outline-light"
              onClick={insertVisaEnquiry}
            >
              + Add Visa Enquiry
            </button>
          </div>
        </div>
        {/* <div className="col-lg-3 mt-3">
          {!isLoggedIn && (
            <ReCaptcha
              setToken={(token: string) => {
                setCaptchaToken(token);
              }}
              myRef={reCaptchaRef}
            />
          )}
        </div> */}

        <div>
          <LoadingButton
            loading={requestLoading}
            onClick={isUpdating ? updateEnquiry : saveEnquiry}
          >
            {isUpdating ? "Update " : "Save "}Enquiry
          </LoadingButton>
        </div>

        <CreateNewAgent
          isModalOpen={handleModalClose}
          handleModalClose={userModalHandleClose}
          url="/query/saveVisaEnquiry"
          queryData={visaQuery}
          changeQueryData={() => {
            updateVisaQuery({
              remark: "",
              visaEnquires: [
                {
                  country: "",
                  visaCategory: "tourist",
                },
              ],
              noOfAdult: 1,
              noOfChild: 0,
              noOfInfant: 0,
              type: "Visa Enquiry",
            });
          }}
        />
      </div>

      <div className="row">
        <div className="mb-3 col-lg-6 col-12">
          <label>Remark</label>
          <CustomCkEditor
            data={visaQuery.remark}
            onChange={(data) => {
              updateVisaQuery((old) => {
                old.remark = data;
                return { ...old };
              });
            }}
          />
        </div>
        <div className="mb-3 col-lg-3 small">
          <AdultChildDetails
            label="Passenger Details"
            onOpen={() => {
              setPassengerPopup(true);
            }}
            onClose={() => {
              setPassengerPopup(false);
            }}
            onSave={(paxInfo) => {
              updateVisaQuery((old) => {
                old.noOfAdult = paxInfo.adult;
                old.noOfChild = paxInfo.child;
                old.noOfInfant = paxInfo.infant;
                return { ...old };
              });
              setPassengerPopup(false);
            }}
            paxInfo={{
              adult: visaQuery.noOfAdult || 1,
              child: visaQuery.noOfChild || 0,
              infant: visaQuery.noOfInfant || 0,
            }}
            show={passengerPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default VisaEnquiryTab;
